import { useEffect } from 'react';

const addBodyBackground = (background: string) => {
  document.body.style.background = background;
  document.body.style.backgroundSize = 'cover';
};

const removeBodyBackground = () => {
  document.body.removeAttribute('style');
};

const useBodyBackground = (style: string) => {
  useEffect(() => {
    addBodyBackground(style);

    return () => {
      removeBodyBackground();
    };
  }, [style]);
};

export default useBodyBackground;
